import React, { useContext } from "react";
import axios from "axios";
import { useState, useEffect } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import { useNavigate, useParams } from "react-router-dom";
import Global from "../../util/Global";
import { ImBlocked } from "react-icons/im";
import { useTranslation } from "react-i18next";
import { DashboardHeaderContext } from "../../components/DashboardHeader";
const USERS_URL = Global.backend + "/index.php/user/showEn";


const AdminDetailEntreprise = () => {

  var height = window.innerHeight;
  var width = window.innerWidth;
  const { t, i18n } = useTranslation();
  const { id } = useParams();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [playOnce, setPlayOnce] = useState(false);
  const [userDetail, setUserDetail] = useState("");


  function fetchUsersDetails() {
    axios
      .post(USERS_URL, {
        userId: id,
      })
      .then((response) => {
        setUserDetail(response.data);

        console.log(response.data);

      })
      .finally(() => {
        setIsLoading(false);
      });
  }


  useEffect(() => {
    if (!playOnce) {
      fetchUsersDetails();

      setPlayOnce(true);
    }
  }, [userDetail]);



  const { setnavLinks, setpageTitle, setpageNavLink, setalertTitle } = useContext(DashboardHeaderContext)

  useEffect(() => {
    setpageNavLink({ path: "/dashboard/admin", label: "adminDashboard" })
    setpageTitle("companyDetails")
    setalertTitle("")
    setnavLinks([{ path: "/adminproducts", label: "companyList"}])
  }, [])


  return (
    <div className="container-fluid">
      <div className="page-content-wrapper">
        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-body">
                <div className="row">
                  {isLoading && (
                    <div
                      style={{ height: height - 100 }}
                      className="d-flex align-items-center justify-content-center"
                    >
                      <CircularProgress color="primary" size={80} />
                    </div>
                  )}
                  {!isLoading && (userDetail.tva != null || userDetail.imm != null || userDetail.immatriculation != null || userDetail.certificat != null) && (
                    <>

                      <table className="table table-bordred">


                        {(userDetail.tva != null && (
                          <tr>
                            <td>Numero de tva</td>
                            <td>{userDetail.tva}</td>
                          </tr>

                        ))}

                        {(userDetail.imm != null && (
                          <tr>
                            <td>immatricule</td>
                            <td>
                              {userDetail.imm}
                            </td>
                          </tr>
                        ))}



                        {(userDetail.immatriculation != null && (

                          <tr >
                            <td>Immatriculation</td>
                            <td ><a target="_blank" href={`${Global.backend}/GIPP_Symfony/uploads/${userDetail.immatriculation}`} rel="noreferrer">{userDetail.immatriculation}</a></td>
                          </tr>

                        ))}



                        {(userDetail.certificat != null && (

                          <tr>
                            <td>certificat</td>
                            <td><a ><a target="_blank" href={`${Global.backend}/GIPP_Symfony/uploads/${userDetail.certificat}`} rel="noreferrer">{userDetail.certificat}</a></a></td>
                          </tr>

                        ))}


                      </table>

                    </>
                  )}


                  {!isLoading && userDetail.tva == null && userDetail.imm == null && userDetail.immatriculation == null && userDetail.certificat == null && (
                    <>


                      <div className="container-fluid">
                        <div className="page-content-wrapper" style={{ minHeight: 500 }}>
                          <div className="row">

                            <div className=" my-main mt-5 mb-5 d-flex align-items-center justify-content-center">
                              <div className="card py-5 w-50">
                                <div className="container" style={{ textAlign: "center" }}>
                                  <ImBlocked
                                    style={{ fontSize: 80, color: "#0e204d", marginBottom: 20 }}
                                  />
                                  <h1 className="text-center">
                                    Fiche d'entreprise vide
                                  </h1>

                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>


                    </>
                  )}



                </div>
              </div>
            </div>


          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminDetailEntreprise;
